const storeNameNumVehicles = 'VTP_NUM_VEHICLES';
const storeNameSelectedVehicle = 'VTP_SELECTED_VEHICLE';
const getSessionStorage = () => {
    try {
        return typeof window !== 'undefined' ? window.sessionStorage : null;
    }
    catch (_a) {
        return null;
    }
};
export const getNumVehiclesOnPLP = () => {
    const storage = getSessionStorage();
    if (storage) {
        const numVehicles = storage.getItem(storeNameNumVehicles);
        if (numVehicles && parseInt(numVehicles, 10) > 0) {
            return parseInt(numVehicles, 10);
        }
    }
    return 12;
};
export const updateNumVehiclesOnPLP = (numVehicles) => {
    const storage = getSessionStorage();
    if (storage) {
        storage.setItem(storeNameNumVehicles, `${numVehicles}`);
    }
};
export const resetNumVehiclesOnPLP = () => {
    const storage = getSessionStorage();
    if (storage) {
        storage.removeItem(storeNameNumVehicles);
        storage.removeItem(storeNameSelectedVehicle);
    }
};
export const setSelectedVehicle = (vehicleId) => {
    const storage = getSessionStorage();
    if (storage) {
        storage.setItem(storeNameSelectedVehicle, vehicleId);
    }
};
export const getSelectedVehicle = () => {
    const storage = getSessionStorage();
    if (storage) {
        return storage.getItem(storeNameSelectedVehicle);
    }
    return undefined;
};
export const scrollToPreviouslySelectedVehicle = () => {
    const previouslySelectedVehicle = getSelectedVehicle();
    if (previouslySelectedVehicle) {
        const tile = document.getElementById(previouslySelectedVehicle);
        if (tile) {
            setTimeout(() => {
                tile.scrollIntoView();
            }, 10);
        }
        setSelectedVehicle('');
    }
};
